import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import BookingsService from '../../services/bookings.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-booking-decline',
	templateUrl: './modal-booking-decline.component.html',
	imports: [ CommonModule, TranslatePipe, ItemErrorComponent, FormsModule ]
})
export class ModalBookingDeclineComponent implements OnInit {
	private bookingsService: BookingsService = inject(BookingsService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalBookingDeclineComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.booking = this.angularHelperService.copy(this.vm.booking) || {};
		this.vm.uid = 'mbd-' + Date.now();
		
		this.vm.handleModalClose = this.handleModalClose;
		this.vm.handleFormSubmit = this.handleFormSubmit;
	}
	
	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid) return;
		this.bookingsService.decline(this.vm.booking);
		this.dialogRef.close();
	}
	
	handleModalClose() {
		this.dialogRef.close();
	}
	
}